import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Img3 from "web/assets/images/signup3.svg";
import axioPath from '../../../../api/axioPath';

const UnsubscribeNewsletter = () => {
  const [text, setText] = useState('Loading...')
  let location = useLocation()
  let history = useHistory()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const userId = queryParams.get("userId")
    const authId = queryParams.get("authId")

    axioPath.get(`user/location/news-letter/${userId}/${authId}`, {
      headers: {
      },
    }).then((response) => {
      if (response?.data?.status === 'SUCCESS') {
        setText('You have been successfully unsubscribed from the email newsletter.')
      } else {
        setText('Process failed, please try again in some time')
      }
    }).catch(() => {
      setText('Process failed, please try again in some time')
    })

  }, [])

  return (
    <div>
      <div style={{ marginTop: '100px', textAlign: 'center', cursor: 'pointer' }}>
        <img
          className="mx-auto mt-4 max-w-sm w-full"
          src={Img3}
          alt="PalletTrader logo"
          loading="lazy"
          width="380"
          height="66"
          onClick={() => history.push('/')}
        />
      </div>
      <div className="mt-6 -text-ms-2 uppercase italic" style={{ fontSize: '10px', marginTop: '20px', textAlign: 'center' }}>
        POWERED BY BETTAWAY
      </div><div className="mt-6 -text-ms-2 uppercase italic" style={{ fontSize: '15px', marginTop: '20px', textAlign: 'center', fontStyle: 'italic' }}>
        {text}
      </div>
    </div>

  )
};

export default UnsubscribeNewsletter;